import { Injectable } from '@angular/core';

import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';

import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import { User } from '../model/user';
import { AuthProvider } from '@firebase/auth-types';

import { DBService } from './db.service';
import { Employee } from '../model/employee';

@Injectable()
export class AuthenticationService extends DBService {

  static USER_ALREADY_EXISTS_CODE: string = 'auth/email-already-in-use';

  constructor(db: AngularFireDatabase, public afAuth: AngularFireAuth, public storage: LocalStorageService) {
    super(db);
  }

  loginWithCredentials(email: string, password: string) {
    return new Promise<void>((resolve, reject) => {
      let errorMessage = 'E-mail e/ou senha inválido(s).';

      console.log('logging...');
      this.afAuth.auth.signInAndRetrieveDataWithEmailAndPassword(email, password)
        .then(result => {
          console.log('ok');
          if (result != null) {
            this.loginSuccess(result);
            resolve();
          } else {
            reject(errorMessage);
          }
        })
        .catch(error => {
          console.log(error);
          reject(errorMessage);
        });
    })
  }

  private login(provider: AuthProvider) {
    return new Promise<void>((resolve, reject) => {

      this.afAuth.auth.signInWithPopup(provider)
        .then(result => {
          if (result != null) {
            this.loginSuccess(result);
            resolve();
          } else {
            reject('Ocorreu um erro ao tentar realizar o login. Por favor, tente novamente.')
          }
        })
        .catch(error => reject(error));
    })
  }

  loginSuccess(result) {
    const user = new User();
    user.uid = result.user.uid;
    user.name = result.user.displayName;
    user.email = result.user.email;

    if (result.credential) {
      console.log(result.credential);
      console.log(JSON.stringify(result.credential));
      user.accessToken = result.credential.accessToken;
    }


    delete user.password;
    this.saveUser(user);

    this.storage.set(User.name, user);

    this.getObject<Employee>(`employees/${user.uid}`)
      .then(employee => {
        this.setAdmin(employee.companyUID === 'I-Ganhei');
        this.setCustomerAdmin(employee.isCompanyAdmin);
        this.setUserCompany(employee.companyUID);
        user.photoURL = employee.photoURL;
        this.storage.set(User.name, user);
        console.log("employee carregado.");
      });
  }

  logout() {
    return new Promise<void>((resolve, reject) => {
      this.afAuth.auth.signOut()
        .then(() => {
          this.storage.remove(User.name);

          resolve();
        })
        .catch(error => reject(error));
    });
  }

  getUser(): User {
    return this.storage.get(User.name);
  }

  isAdmin(): boolean {
    return this.storage.get('isAdmin');
  }

  setAdmin(isAdmin: boolean) {
    return this.storage.set('isAdmin', isAdmin);
  }

  isCustomerAdmin(): boolean {
    return this.storage.get('isCustomerAdmin');
  }

  setCustomerAdmin(isAdmin: boolean) {
    return this.storage.set('isCustomerAdmin', isAdmin);
  }

  getUserCompany(): string {
    return this.storage.get('companyUID');
  }

  setUserCompany(uid: string) {
    return this.storage.set('companyUID', uid);
  }

  createUser(employee: Employee) {
    return new Promise<void>((resolve, reject) => {
      this.afAuth.auth.createUserWithEmailAndPassword(employee.email, employee.password)
        .then(result => {
          if (result) {
            this.afAuth.auth.currentUser.sendEmailVerification();

            this.afAuth.auth.currentUser.updateProfile({
              displayName: employee.name,
              photoURL: ''
            }).then(() => resolve());
          }
        });
    });
  }

  createUserAndRegister(employee: Employee) {
    return new Promise<void>((resolve, reject) => {
      this.afAuth.auth.createUserWithEmailAndPassword(employee.email, employee.password)
        .then(result => {
          if (result) {
            this.afAuth.auth.currentUser.sendEmailVerification();

            this.afAuth.auth.currentUser.updateProfile({
              displayName: employee.name,
              photoURL: ''
            }).then(() => {
              employee.uid = this.afAuth.auth.currentUser.uid;

              const path = 'employees/' + employee.uid;

              this.getObject<Employee>(path)
                .then(u => {
                  if (u == null) {
                    this.insert<Employee>(path, employee)
                      .then(result => resolve())
                      .catch(error => reject(error));
                  }
                });
            })
              .catch(error => {
                console.log(error);
                resolve();
              });
          }
        })
        .catch(error => {
          if (error.code == AuthenticationService.USER_ALREADY_EXISTS_CODE) {
            reject('E-mail já cadastrado');
          } else {
            console.log(error);
            reject('Ocorreu um erro ao tentar realizar o cadastro. Por favor, tente novamente.');
          }
        });
    });
  }

  createEmployee(employee: Employee) {
    return this.insertInList<Employee>('employees', employee);
  }

  saveUser(user: User) {
    let path = 'users/' + user.uid;

    this.getObject<User>(path)
      .then(u => {
        if (u == null) {
          this.insert<User>(path, user);
        }
      })
  }

  saveEmployee(employee: Employee) {

  }

  sendRecoveryPasswordEmail(email: string) {
    this.afAuth.auth.sendPasswordResetEmail(email);
  }

  getCurrentUser() {
    return this.afAuth.authState;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/authentication.service.ts